import { render, staticRenderFns } from "./CofaceDraRenderer.vue?vue&type=template&id=1bf37f1a&"
import script from "./CofaceDraRenderer.vue?vue&type=script&lang=js&"
export * from "./CofaceDraRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports